'use client';

import { FC, useState } from 'react';

import { RegistrationNumber } from '@ravago/shared/page-data/models/elements/registration-number.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   registrationNumbers: Array<RegistrationNumber>;
   trim?: boolean;
}

export const RegistrationNumberList: FC<Props> = ({ registrationNumbers, trim = false }) => {
   const translate = useTranslations();
   const [open, setOpen] = useState(false);

   if (registrationNumbers?.length === 0) {
      return (
         <Typography color="subtle" variant="small">
            {translate('registration-numbers.no-registration-numbers-found')}
         </Typography>
      );
   }

   const trimmedRegistrationNumbers = trim && !open ? registrationNumbers.slice(0, 1) : registrationNumbers;
   const totalCount = registrationNumbers.length;

   return (
      <Box direction="column">
         {trimmedRegistrationNumbers.map(({ registrationNumber, type }) => (
            <Paper data-testid="registration-number__list-item" shadow key={registrationNumber}>
               <Box direction="row">
                  <Typography data-testid="registration-number" component="h3" variant="body-highlight">
                     {registrationNumber}
                  </Typography>
               </Box>

               <Box direction="column" gap="2xs">
                  <Typography data-testid="registration-number__type" variant="body">
                     {type}
                  </Typography>
               </Box>
            </Paper>
         ))}

         {trim && totalCount > 1 && !open && (
            <Box justify="end">
               <Button variant="tertiary" leadingIcon="chevron-down" onClick={() => setOpen(true)}>
                  {translate('company-info.show-more', { count: totalCount - 1 })}
               </Button>
            </Box>
         )}
      </Box>
   );
};
